import * as ActionTypes from 'constants';

export const fetchMarkers = bounds => ({ type: ActionTypes.FETCH_MARKERS, payload: bounds });
export const setMarkersFilters = filters => ({ type: ActionTypes.SET_MARKERS_FILTERS, payload: { filters } });
export const fetchNextMarkers = f => ({ type: ActionTypes.FETCH_NEXT_MARKERS});
export const toggleCanvassing = bool => ({ type: ActionTypes.TOGGLE_CANVASSING, payload: { canvassing: bool } });
export const createMarker = marker => ({ type: ActionTypes.CREATE_MARKER, payload:{ marker } });
export const updateMarker = marker => ({ type: ActionTypes.UPDATE_MARKER, payload:{ marker } });
export const deleteMarker = marker => ({ type: ActionTypes.DELETE_MARKER, payload:{ marker } });
export const toggleShowMarkerSettings = val => ({ type: ActionTypes.TOGGLE_SHOW_MARKER_SETTINGS, payload: val });
export const setMarkerTypes = marker_types => ({ type: ActionTypes.SET_MARKER_TYPES, payload: marker_types });
export const initMapMarkerTypes = () => ({ type: ActionTypes.INIT_MAP_MARKER_TYPES });
export const setNewMarkerType = marker => ({ type: ActionTypes.SET_NEW_MARKER_TYPE, payload: marker });
export const toggleShowCreateNewMarkerModal = bool => ({ type: ActionTypes.TOGGLE_SHOW_CREATE_NEW_MARKER_MODAL, payload: bool });
export const toggleShowEditMarkerModal = bool => ({ type: ActionTypes.TOGGLE_SHOW_EDIT_MARKER_MODAL, payload: bool });
export const toggleMarkerTypesInitialized = bool => ({ type: ActionTypes.TOGGLE_MARKER_TYPES_INITIALIZED, payload: bool });
export const updateMarkerFilters = filters => ({ type: ActionTypes.UPDATE_MARKER_FILTERS, payload: filters });
export const updateMarkerFilterUser = user => ({ type: ActionTypes.UPDATE_MARKER_FILTER_USER, payload: user });



// WEBPACK FOOTER //
// ./src/common/actions/markers.js